import React from 'react'
import {Link, withRouter} from "react-router-dom"
import LogInIcon from 'react-icons/lib/fa/sign-in'
import UserIcon from 'react-icons/lib/fa/user'
import TeamIcon from 'react-icons/lib/fa/group'
import {getCurrentTeam} from "../../dataHelpers/authenticationHelpers"
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle, NavItem} from 'reactstrap'
import {ADMIN_URL, SERVER_LOG_URL, GRAFANA_URL} from "../../api"


class AuthNavItem extends React.Component {
    constructor(props) {
        super(props)
        const {history, user, teamName, toggleTeamSwitcherModal, loading} = props

        this.history = history
        this.toggleTeamSwitcherModal = toggleTeamSwitcherModal
        let userName, userIsDealer, userIsSupport, userCanManageTeam, userCanViewControllers, manyTeams
        this.user = user
        if (user && user.groups && user.groups.length) {
            userName = this.user.name
            userIsSupport = this.user.groups.includes('Support')
            userIsDealer = this.user.groups.includes('Dealers')
            userCanManageTeam = this.user.canManageTeam
            userCanViewControllers = this.user.canViewControllers
            manyTeams = this.user.teams && this.user.teams.length && this.user.teams.length > 1
        }

        this.state = {
            userName,
            teamName,
            userIsDealer,
            userIsSupport,
            userCanManageTeam,
            userCanViewControllers,
            manyTeams,
            loading,
            dropdownOpen: false
        }

        this.toggle = this.toggle.bind(this)
    }

    get viewControllersLink() {
        return (this.state.manyTeams ? `/teams/${getCurrentTeam()}/controllers` : "/controllers")
    }

    componentWillReceiveProps(nextProps) {
        const {history, user, teamName, toggleTeamSwitcherModal, loading} = nextProps
        this.history = history
        this.toggleTeamSwitcherModal = toggleTeamSwitcherModal
        let userName, userIsDealer, userIsSupport, userCanManageTeam, userCanViewControllers, manyTeams
        this.user = user
        if (user && this.user.groups && this.user.groups.length) {
            userName = this.user.name
            userIsSupport = this.user.groups.includes('Support')
            userIsDealer = this.user.groups.includes('Dealers')
            userCanManageTeam = this.user.canManageTeam
            userCanViewControllers = this.user.canViewControllers
            manyTeams = this.user.teams && this.user.teams.length && this.user.teams.length > 1
        }

        this.setState({
            userName,
            teamName,
            userIsDealer,
            userIsSupport,
            userCanManageTeam,
            userCanViewControllers,
            loading,
            manyTeams
        })
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        })
    }

    render() {
        let {
            dropdownOpen,
            userName,
            teamName,
            userCanManageTeam,
            userCanViewControllers,
            userIsDealer,
            userIsSupport,
            loading,
            manyTeams
        } = this.state

        if (loading) {
            return null
        }

        if (!userName || !userName.length) {
            return (
                <NavItem>
                    <Link to="/login" className="nav-link">
                        <LogInIcon/>
                        Log In
                    </Link>
                </NavItem>)
        }

        return <Dropdown nav isOpen={dropdownOpen} toggle={this.toggle}>
            <DropdownToggle nav caret>
                <UserIcon/> {userName}
            </DropdownToggle>
            <DropdownMenu right>
                <Link to="/account">
                    <DropdownItem>
                        Manage Account
                    </DropdownItem>
                </Link>

                {(userCanManageTeam ?
                    <Link to="/team">
                        <DropdownItem>
                            Manage Team
                        </DropdownItem>
                    </Link> :
                    null)}

                {(userCanViewControllers ?
                    <Link to={this.viewControllersLink}>
                        <DropdownItem>
                            View Controllers
                        </DropdownItem>
                    </Link> :
                    null)}

                {(userIsDealer ? <DropdownItem divider/> : null)}
                {(userIsDealer ?
                    <Link to="/dealer">
                        <DropdownItem>
                            Dealer Control Panel
                        </DropdownItem>
                    </Link> :
                    null)}

                {(userIsSupport ? <DropdownItem divider/> : null)}
                {(userIsSupport ?
                    <Link to="/management/controllers">
                        <DropdownItem>
                            Search All Controllers
                        </DropdownItem>
                    </Link> :
                    null)}
                {(userIsSupport ?
                    <Link to="/management/teams">
                        <DropdownItem>
                            Search All Teams
                        </DropdownItem>
                    </Link> :
                    null)}
                {(userIsSupport ?
                    <Link to="/management/users">
                        <DropdownItem>
                            Search All Users
                        </DropdownItem>
                    </Link> :
                    null)}
                {(userIsSupport ? <DropdownItem divider/> : null)}
                {(userIsSupport ?
                    <Link to="/management/support">
                        <DropdownItem>
                            Support Control Panel
                        </DropdownItem>
                    </Link> :
                    null)}
                {(userIsSupport ?
                    <a target="_blank" href={ADMIN_URL}>
                        <DropdownItem>
                            Django Admin Panel
                        </DropdownItem>
                    </a> :
                    null)}
                {(userIsSupport ?
                    <a target="_blank" href={GRAFANA_URL}>
                        <DropdownItem>
                          Grafana Traffic Monitoring
                        </DropdownItem>
                    </a> :
                    null)}
                {(userIsSupport ?
                    <a target="_blank" href={SERVER_LOG_URL}>
                        <DropdownItem>
                            Marksman Server Log
                        </DropdownItem>
                    </a> :
                    null)}

                {(manyTeams ?
                    <DropdownItem divider/> :
                    null)}
                {(manyTeams && teamName && teamName.length ?
                    <DropdownItem disabled>
                        <TeamIcon/>&ensp;{teamName}
                    </DropdownItem> :
                    null)}
                {(manyTeams ?
                    <DropdownItem onClick={this.toggleTeamSwitcherModal}>
                        Switch Teams
                    </DropdownItem> :
                    null)}

                <DropdownItem divider/>
                <Link to={"/logout"}>
                    <DropdownItem>
                        Log Out
                    </DropdownItem>
                </Link>
            </DropdownMenu>
        </Dropdown>
    }
}

export default withRouter(AuthNavItem)



// WEBPACK FOOTER //
// ./src/components/ui/AuthNavItem.js